import { Badge, Box, Card, Flex, Grid, Tooltip } from '@mantine/core';
import {
  IconBrandAws,
  IconBrandGoogleFilled,
  IconCirclesFilled,
  IconHistory,
  IconPlugConnected,
  IconUser,
} from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import prettifiedLabel from '../../constants/labelPrettifier';
import PipelineStats from './PipelineStats';

const PipelinesCard = ({ pipeline, stats, period, status }) => {
  const { domain } = useSelector((state) => state.domain);
  const link = `#/accounts/${domain.accountId}/domains/${domain.id}/pipelines/${pipeline.id}/details`;

  let OutputIcon = IconCirclesFilled;

  if (pipeline.outputType === 's3') {
    OutputIcon = IconBrandAws;
  } else if (pipeline.outputType === 'gcs') {
    OutputIcon = IconBrandGoogleFilled;
  }

  return (
    <Card key={pipeline.id} mb="lg" withBorder>
      <Card.Section inheritPadding py="sm" bg="white" style={{ textAlign: 'left' }}>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Box>
              <a href={link}>
                <strong>{pipeline.name}</strong>
              </a>
            </Box>
            <Flex gap="xs" mt="xs">
              <Badge variant="default">
                {pipeline.type === 'event' ? (
                  <>
                    <IconPlugConnected size={14} /> Events{' '}
                    {pipeline.events.length > 0 && pipeline.eventsAction === 'exclude' ? 'excluding' : 'including'}{' '}
                    {pipeline.events.join(', ') || 'all'}
                  </>
                ) : (
                  <>
                    <IconUser size={14} /> Profile updates
                  </>
                )}
              </Badge>

              <Badge variant="default">
                <OutputIcon size={14} /> {prettifiedLabel(pipeline.outputType)}
              </Badge>

              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(pipeline.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(pipeline.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Flex>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <PipelineStats stats={stats} pipeline={pipeline} period={period} />
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 2 }}>{status}</Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default PipelinesCard;
